// extracted by mini-css-extract-plugin
module.exports = {"LabelPill":"_3NWZrRsu","icons":"_1vPmE89z","smallIcon":"_1u37Aod1","largeIcon":"Ol-Cu14m","content":"_2TEqWqvs","labelIcon":"_3aboBoUt","clickable":"_3S24785J","link":"_38aeJJv8"};